import axios from 'axios';
import { attachAuth } from '@/utils/authSession';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || "http://localhost:9000/",
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
});

const apiAuthClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || "http://localhost:9000",
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
});

const normalizeTimeAgoValue = (value) => {
  if (typeof value !== 'string') return value;
  return value.replace(/-\d+\s+seconds ago/i, 'seconds ago');
};

const normalizeTimeAgoDeep = (payload) => {
  if (Array.isArray(payload)) {
    payload.forEach(normalizeTimeAgoDeep);
    return payload;
  }

  if (payload && typeof payload === 'object') {
    Object.keys(payload).forEach((key) => {
      if (key === 'timeAgo') {
        payload[key] = normalizeTimeAgoValue(payload[key]);
      } else {
        normalizeTimeAgoDeep(payload[key]);
      }
    });
  }

  return payload;
};

const applyTimeAgoSanitizer = (response) => {
  if (response && response.data) {
    normalizeTimeAgoDeep(response.data);
  }
  return response;
};

// Sends token when present, proceeds without it when absent (for public endpoints that return viewerState)
const apiOptionalAuthClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || "http://localhost:9000/",
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
});

apiClient.interceptors.response.use(applyTimeAgoSanitizer);
apiAuthClient.interceptors.response.use(applyTimeAgoSanitizer);
apiOptionalAuthClient.interceptors.response.use(applyTimeAgoSanitizer);

attachAuth(apiOptionalAuthClient);
attachAuth(apiAuthClient, { optional: false });

  export default {
    getAllArticles(){
        return apiOptionalAuthClient.get('/articles')
    },
    getAllArticleContent(){
        return apiClient.get('/allArticlesContent')
    },
    getArticleContent(id){
        return apiClient.get(`/article/post/${id}`)
    },
    getArticleData(id){
        return apiClient.get(`/article/data/${id}`)
    },
    listTrendingArticles(){
        return apiOptionalAuthClient.get(`/articles/trending`)
    },
    listNbaArticles(){
        return apiOptionalAuthClient.get('/articles/nba')
    },
    listNflArticles(){
        return apiOptionalAuthClient.get('/articles/nfl')
    },
    listNhlArticles(){
        return apiOptionalAuthClient.get('/articles/nhl')
    },
    listMmaArticles(){
        return apiOptionalAuthClient.get('/articles/mma')
    },
    listBusinessArticles(){
        return apiOptionalAuthClient.get('/articles/business')
    },
    listTechnologyArticles(){
        return apiOptionalAuthClient.get('/articles/technology')
    },
    listMovieArticles(){
        return apiOptionalAuthClient.get('/articles/entertainment/movies')
    },
    listTvArticles(){
        return apiOptionalAuthClient.get('/articles/entertainment/television')
    },
    listMusicArticles(){
        return apiOptionalAuthClient.get('/articles/entertainment/music')
    },
    listLeftWingArticles(){
        return apiOptionalAuthClient.get('/articles/politics/left')
    },
    listRightWingArticles(){
        return apiOptionalAuthClient.get('/articles/politics/right')
    },
    listCenterArticles(){
        return apiOptionalAuthClient.get('/articles/politics/center')
    },
    listPoliticsArticles(){
        return apiClient.get('/articles/politics')
    },
    listIntheaters(){
        return apiClient.get('/nowPlaying')
    },
    listComingSoon(){
        return apiClient.get('/comingSoon')
    },
    listContentBasedArticles(){
        return apiAuthClient.get(`/curatedContentBased`)
    },
    listArticlesBasedOnLikes(){
        return apiAuthClient.get(`/contentBasedOnLikes`)
    },
    listSuggestedContentBasedArticles(articleId){
        return apiClient.get(`/youMayAlsoRead/${articleId}`)
    },
    listCollaborativeArticles(id){
        return apiAuthClient.get(`/improvedMatrixFactorizationArticles/${id}`)
    },
    listCollaborativeArticlesFromDb(){
        return apiAuthClient.get(`/matrixFactorizationArticlesFromDb`)
    },
    listFwlsArticles(){
        return apiAuthClient.get(`/fwlsArticles`)
    },
    listFwlsArticlesFromDb(){
        return apiAuthClient.get(`/fwlsArticlesFromDb`)
    },
    listSearchedArticles(searchTerm){
        return apiOptionalAuthClient.get(`/searchArticles/${searchTerm}`)
    },
    listNewsletterForYouArticles(){
        return apiAuthClient.get(`/newsletterForYou`)
    },
    listArticlesForNewsletter(){
        return apiClient.get('/newsletter/articles')
    }
}